module.exports = __webpack_public_path__ + "static/media/printer.0363f154.svg";